import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {SelectedItem} from '../../order/models/order';
import {Site} from '../../shared/models/site';

export const sitesSelectedActionTypes = {
  LOAD: type('[order] Load sites selected'),
  LOAD_SUCCESS: type('[order] Load sites selected Success'),
  LOAD_FAIL: type('[order] Load sites selected Fail'),
  CLEAR: type('[order] Clear sites selected'),
};

export class LoadSitesSelectedAction implements Action {
  readonly type = sitesSelectedActionTypes.LOAD;
  constructor(public payload?: SelectedItem[]) {}
}

export class LoadSitesSelectedSuccessAction implements Action {
  readonly type = sitesSelectedActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Site[]) {}
}

export class LoadSitesSelectedFailAction implements Action {
  readonly type = sitesSelectedActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class ClearSitesSelectedAction implements Action {
  readonly type = sitesSelectedActionTypes.CLEAR;
  constructor() {}
}

